import React from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon, WalletIcon, BrainIcon, HeartIcon, UserCheckIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section className="bg-gradient-to-b from-zinc-950 via-emerald-950/10 to-zinc-950 py-16 sm:py-24" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-3">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-4">
            Beneficios reales{' '}
            <span className="text-emerald-400" data-id="element-5">(traducidos a tu vida)</span>
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-6">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex items-start gap-4 bg-zinc-900/50 border border-zinc-800 rounded-xl p-6" data-id="element-7">
            <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-8">
              <TrophyIcon className="w-6 h-6 text-emerald-400" data-id="element-9" />
            </div>
            <div data-id="element-10">
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-11">
                Ver el partido esta noche
              </h3>
              <p className="text-zinc-400" data-id="element-12">
                No la próxima semana cuando "por fin lo instales"
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex items-start gap-4 bg-zinc-900/50 border border-zinc-800 rounded-xl p-6" data-id="element-13">
            <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-14">
              <WalletIcon className="w-6 h-6 text-amber-400" data-id="element-15" />
            </div>
            <div data-id="element-16">
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-17">
                Dejar de pagar suscripciones que no usas
              </h3>
              <p className="text-zinc-400" data-id="element-18">
                Con acceso a más de 1.000 canales sin costo mensual
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex items-start gap-4 bg-zinc-900/50 border border-zinc-800 rounded-xl p-6" data-id="element-19">
            <div className="w-12 h-12 bg-cyan-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-20">
              <BrainIcon className="w-6 h-6 text-cyan-400" data-id="element-21" />
            </div>
            <div data-id="element-22">
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-23">
                Sentirte capaz con la tecnología
              </h3>
              <p className="text-zinc-400" data-id="element-24">
                Porque seguiste una guía que sí funciona
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex items-start gap-4 bg-zinc-900/50 border border-zinc-800 rounded-xl p-6" data-id="element-25">
            <div className="w-12 h-12 bg-pink-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-26">
              <HeartIcon className="w-6 h-6 text-pink-400" data-id="element-27" />
            </div>
            <div data-id="element-28">
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-29">
                Ayudar a tu familia
              </h3>
              <p className="text-zinc-400" data-id="element-30">
                Instálalo en la tele de tu casa y sé el héroe de la tarde
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex items-start gap-4 bg-zinc-900/50 border border-zinc-800 rounded-xl p-6" data-id="element-31">
            <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-32">
              <UserCheckIcon className="w-6 h-6 text-purple-400" data-id="element-33" />
            </div>
            <div data-id="element-34">
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-35">
                Nunca más depender de un técnico
              </h3>
              <p className="text-zinc-400" data-id="element-36">
                Para instalar una simple aplicación
              </p>
            </div>
          </motion.div>
        </div>

        {/* One-liner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-12 text-center" data-id="element-37">
          <p className="text-xl sm:text-2xl text-zinc-300 italic" data-id="element-38">
            "Lo que un técnico te cobra por hacer, esta guía te lo enseña{' '}
            <span className="text-emerald-400 font-bold not-italic" data-id="element-39">
              para siempre.
            </span>
            "
          </p>
        </motion.div>
      </div>
    </section>;
}